/**
 * Weather fetcher with client-side fallback.
 *
 * The production container has occasionally been unable to reach
 * api.open-meteo.com (egress restriction), so we try the backend proxy first
 * (which also gives us MongoDB caching) and fall back to calling Open-Meteo
 * directly from the browser. Open-Meteo is public, keyless and CORS-open,
 * so this fallback works from any client without a proxy.
 */
import { api } from "@/api/client";

const OPEN_METEO_URL = "https://api.open-meteo.com/v1/forecast";

function buildQuery(lat, lng) {
  return (
    `?latitude=${lat}&longitude=${lng}` +
    "&current=temperature_2m,apparent_temperature,weather_code," +
    "wind_speed_10m,wind_direction_10m,relative_humidity_2m,is_day" +
    "&daily=temperature_2m_max,temperature_2m_min,weather_code," +
    "sunrise,sunset,precipitation_probability_max,wind_speed_10m_max" +
    "&timezone=Europe/Rome&forecast_days=3"
  );
}

export async function fetchWeather(lat, lng) {
  // 1) Try backend proxy (benefits from MongoDB cache + logging)
  try {
    const res = await api.get(`/weather?lat=${lat}&lng=${lng}`);
    if (res?.data && !res.data.error && res.data.current) return res.data;
  } catch (_) {
    /* fall through to direct call */
  }

  // 2) Direct call to Open-Meteo — bypasses any backend egress issue
  try {
    const r = await fetch(`${OPEN_METEO_URL}${buildQuery(lat, lng)}`);
    if (!r.ok) return null;
    const data = await r.json();
    data.fetched_at = new Date().toISOString();
    return data;
  } catch (_) {
    return null;
  }
}
